import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StationApi } from './station';


export interface StationInterface {
    _id: string;
    name: string;
    location: {
        coordinates:[number,number];
    };
    address: string;
}

const initialState: StationInterface = {
    _id: '',
    name: '',
    location: {
        coordinates:[0,0],
    },
    address: '',
};

export const StationSlice = createSlice({
    name: 'Stations',
    initialState,
    reducers: {
        saveStations: (
            state: StationInterface,
            action: PayloadAction<StationInterface>
        ) => {
            return { ...state, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                StationApi.endpoints.getStationById.matchFulfilled,
                (
                    state: StationInterface,
                    action: PayloadAction<StationInterface>
                ) => {
                    return { ...state, ...action.payload };
                }
            )
            .addMatcher(
                StationApi.endpoints.getStationList.matchFulfilled,
                (
                    state: StationInterface,
                    action: PayloadAction<StationInterface>
                ) => {
                    return { ...state, ...action.payload };
                }
            );
    },
});

export const { saveStations } = StationSlice.actions;

export default StationSlice.reducer;
